export class Profile{
  private _family_name : string;
  private _given_name : string;
  private _sub : string;
  private _groups : string[];


  get family_name(): string {
    return this._family_name;
  }

  set family_name(value: string) {
    this._family_name = value;
  }

  get given_name(): string {
    return this._given_name;
  }

  set given_name(value: string) {

    this._given_name = value;
  }

  get sub(): string {
    return this._sub;
  }

  set sub(value: string) {
    this._sub = value;
  }

  get groups(): string[] {
    return this._groups;
  }

  set groups(value: string[]) {
    this._groups = value;
  }
}



// WEBPACK FOOTER //
// ../../src/lib/profile.ts